import { useTranslation } from '@/i18n';
import { ButtonV2, ButtonV2Size } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, useCallback, useState } from 'react';
import styles from '../../column.module.scss';

const cx = classnames.bind(styles);

type Props = {
  onClick: () => Promise<void>;
  size: ButtonV2Size;
};

export const DownloadButton: FC<Props> = memo(({ onClick: _onClick, size }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const onClick = useCallback(async () => {
    setIsLoading(true);
    await _onClick();
    setIsLoading(false);
  }, [_onClick]);
  return (
    <ButtonV2
      isTertiary
      size={size}
      onClick={onClick}
      isLoading={isLoading}
      className={cx('download-button')}
    >
      {t('export_file_download')}
    </ButtonV2>
  );
});
DownloadButton.displayName = 'DownloadButton';
